import PlusThinIcon from '@repo/ui/components/Icon/PlusThinIcon';

import { Description, StyledButtonWrapper } from './styles';
import { CreateNewTeamButtonProps } from './types';

const CreateNewTeamButton: React.FC<CreateNewTeamButtonProps> = (props) => {
  return (
    <StyledButtonWrapper theme={props.theme} onClick={props.onClick}>
      <PlusThinIcon height="16px" />
      <Description theme={props.theme}>Create New Team</Description>
    </StyledButtonWrapper>
  );
};

export default CreateNewTeamButton;
